import {DomSanitizer} from '@angular/platform-browser';
import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';
import {Scene1Floor, Scene2Floor, Scene3Floor, Scene4Floor, Scene5Floor, Scene6Floor, Scene7Floor} from 'src/assets/config/frames/scene.enum';
import {FloorService} from '../../services/floor.service';

@Component({
  selector: 'app-frame',
  templateUrl: './frame.component.html',
  styleUrls: ['./frame.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FrameComponent implements OnInit {
  floors = [Scene1Floor, Scene2Floor, Scene3Floor, Scene4Floor, Scene5Floor, Scene6Floor, Scene7Floor];

  @Input() frame: any;

  constructor(
      public sanitizer: DomSanitizer,
      public floorService: FloorService
  ){ }

  ngOnInit(): void {
  }
}
